import { render, staticRenderFns } from "./GridMod.vue?vue&type=template&id=2a7a4fb7"
import script from "./GridMod.vue?vue&type=script&lang=js"
export * from "./GridMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports